export default {
  required: field => `Please enter ${field}.`,
  email: () => 'Please enter a correct email format.',
  iban: field => `Please enter a valid ${field}.`,
  regex: () => 'Password needs to be at least 8 characters long, include both lowercase and uppercase letters, and numbers.',
  numeric: () => 'Please enter a numeric value.',
};
